import { INLINE_TYPES } from 'ContentEditorUI/lib/inpage/Constants';
export const BAYMAX_RESPONSIVE_MODULE_PADDING = 3;
export const CLEAN_LINES_RESPONSIVE_MODULE_PADDING = 1;
export const TOOLBAR_SIZING_MIN_PADDING = 10;
export const SELECTED_TOOLBAR_OFFSET = 26;
export const TOOLBAR_TYPES = {
  DESKTOP: Object.freeze({
    MODULE_IN_FLEX_COLUMN_TOOLBAR_TYPE: 'module-in-flex-column-desktop',
    MODULE_OUTSIDE_CONTAINER_TOOLBAR_TYPE: 'module-outside-container-desktop',
    MODULE_IN_RICH_TEXT: 'module-in-rich-text-desktop',
    SECTION_TOOLBAR_TYPE: 'section-desktop',
    COLUMN_TOOLBAR_TYPE: 'column-desktop',
    ROW_TOOLBAR_TYPE: 'row-desktop',
    MODULE_TOOLBAR_TYPE: 'module-desktop',
    EMPTY_CONTAINER_TOOLBAR_TYPE: 'empty-container-desktop',
    ADVANCED_MODULE_WITHOUT_ACCESS: 'advanced-module-without-access',
    EDITABLE_MODULE_WITHOUT_ACCESS: 'editable-module-without-access',
    INSERT_NEW_SECTION_HANDLE_TYPE: 'insert-new-section-handle-desktop'
  }),
  MOBILE: Object.freeze({
    MODULE_IN_FLEX_COLUMN_TOOLBAR_TYPE: 'module-in-flex-column-mobile',
    MODULE_OUTSIDE_CONTAINER_TOOLBAR_TYPE: 'module-outside-container-mobile',
    MODULE_IN_RICH_TEXT: 'module-in-rich-text-mobile',
    SECTION_TOOLBAR_TYPE: 'section-mobile',
    COLUMN_TOOLBAR_TYPE: 'column-mobile',
    ROW_TOOLBAR_TYPE: 'row-mobile',
    ROW_TOOLBAR_WITH_HIDE_ICON_TYPE: 'row-mobile-with-hide-icon',
    MODULE_TOOLBAR_TYPE: 'module-mobile',
    EMPTY_CONTAINER_TOOLBAR_TYPE: 'empty-container-mobile',
    INSERT_NEW_SECTION_HANDLE_TYPE: 'insert-new-section-handle-mobile',
    ADVANCED_MODULE_WITHOUT_ACCESS: 'advanced-module-without-access-mobile'
  })
};

// section, column, row,  module, and empty-container
export const NUMBER_DND_AREA_TOOLBAR_TYPES = 5;
function isOfType(val) {
  return obj => obj.type === val;
}

// CR - Note, this needs to be generic for the type-guard to work
export const getDragHandleByType = (currentDragHandles, dragHandleType) => {
  return currentDragHandles ? currentDragHandles.find(isOfType(dragHandleType)) : null;
};
export const findAppropriateToolbarSize = (dimensionsBySizes, nodeSize) => {
  let sizeKey;

  // Assumes insertion order of dimensionsBySizes is by biggest to smallest
  for (sizeKey of Object.keys(dimensionsBySizes)) {
    const dimensionForSize = dimensionsBySizes[sizeKey];
    if (nodeSize - TOOLBAR_SIZING_MIN_PADDING > dimensionForSize) {
      return sizeKey;
    }
  }
  return sizeKey;
};
export const adjustedToolbarLeftToStayInViewport = ({
  moduleLeft,
  moduleWidth,
  previewViewportWidth,
  scrollLeftPosition,
  toolbarWidth,
  toolbarLeft
}) => {
  const furthestWidthInViewport = previewViewportWidth + scrollLeftPosition;
  const moduleRight = moduleLeft + moduleWidth;
  const moduleWidthVisible = Math.min(furthestWidthInViewport, moduleRight) - moduleLeft;
  if (toolbarLeft + scrollLeftPosition + toolbarWidth > furthestWidthInViewport && moduleLeft < furthestWidthInViewport && moduleRight > furthestWidthInViewport) {
    if (moduleWidthVisible > toolbarWidth) {
      return furthestWidthInViewport - toolbarWidth;
    } else {
      return moduleLeft;
    }
  } else if (toolbarLeft < 0) {
    return 0;
  }
  return toolbarLeft;
};
export const adjustResponsiveToolbarToStayInViewPort = ({
  measuredWidths,
  left,
  top,
  width,
  previewViewportWidth,
  scrollLeftPosition,
  toolbarHeight,
  isSelected,
  showEditModuleOnSelected = false
}) => {
  const responsiveSize = findAppropriateToolbarSize(measuredWidths, width);
  const offset = isSelected && !showEditModuleOnSelected && responsiveSize === 'default' ? SELECTED_TOOLBAR_OFFSET : 0;
  const toolbarWidth = measuredWidths[responsiveSize] - offset;
  const adjustedTop = Math.round(top) - toolbarHeight;
  if (adjustedTop > 0) {
    top = isSelected ? adjustedTop : Math.round(top);
  } else {
    top = Math.round(top);
  }
  top = isSelected ? top - CLEAN_LINES_RESPONSIVE_MODULE_PADDING : top + CLEAN_LINES_RESPONSIVE_MODULE_PADDING;
  let toolbarLeft = Math.round(left) + Math.round(width) - toolbarWidth - (isSelected ? 0 : CLEAN_LINES_RESPONSIVE_MODULE_PADDING);
  toolbarLeft = adjustedToolbarLeftToStayInViewport({
    moduleLeft: left,
    moduleWidth: Math.round(width),
    previewViewportWidth,
    scrollLeftPosition,
    toolbarWidth,
    toolbarLeft
  });
  return {
    responsiveSize,
    left: toolbarLeft,
    top,
    width: toolbarWidth
  };
};
export const shouldShowEditModuleOnSelected = ({
  isPatagoniaSidebarCollapsed,
  moduleType
}) => {
  const isInline = INLINE_TYPES.indexOf(moduleType);
  return Boolean(isPatagoniaSidebarCollapsed && isInline);
};